import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { list, checkupSave } from "../../requests/diagnosis";
import { createSignal } from "solid-js";

export default function useCheckupDiagnosis(props) {

  const [diagnoses, setDiagnoses] = createSignal([]);
  const [statuses, setStatuses] = createSignal([
    {
      value: "in progress",
      text: "In Progress",
    },
    {
      value: "completed",
      text: "Completed",
    },
    {
      value: "abandoned",
      text: "Abandoned",
    },
  ]);

  const [diagnosisForm, setDiagnosisForm] = createStore({
    diagnoses: props.diagnoses || [],
    diagnosisId: null,
  });

  const { successToast, errorToast } = useApplication();

  const addDiagnosis = () => {
    if (!diagnosisForm.diagnosisId) {
      errorToast("Please select a diagnosis");
      return;
    }

    const exist = diagnosisForm.diagnoses.find(diagnosis => diagnosis.diagnosisId === diagnosisForm.diagnosisId);
    if (exist) {
      errorToast("Diagnosis already added");
      return;
    }

    const diagnosis = diagnoses().find(diagnosis => diagnosis.value === diagnosisForm.diagnosisId);
    if (!diagnosis) {
      errorToast("Diagnosis not found");
      return;
    }

    setDiagnosisForm('diagnoses', [...diagnosisForm.diagnoses, {
      key: crypto.randomUUID(),
      uid: null,
      diagnosisId: diagnosisForm.diagnosisId,
      originalStatus: "new", // Default status for new diagnoses
      status: "new",
      name: diagnosis.text,
    }]);

    diagnosisForm.diagnosisId = null;
  }

  const updateDiagnosisStatus = (key, status) => {
    setDiagnosisForm('diagnoses', diagnosis => diagnosis.key === key, 'status', status);
  }

  const removeDiagnosis = (key) => {
    setDiagnosisForm('diagnoses', diagnosisForm.diagnoses.filter(diagnosis => diagnosis.key !== key));
  }

  const onFetchDiagnoses = async () => {
    try {
      const data = await list();
      setDiagnoses(data.list || []);
    } catch(error) {
      setDiagnoses([]);
    }
  }

  const onSaveDiagnosis = async () => {

    props.setLoading(true);
    try {
      const formData = new FormData();
      formData.append('diagnoses', JSON.stringify(diagnosisForm.diagnoses));

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Diagnosis saved successfully");
      } else {
        errorToast(data.message || "Failed to save diagnosis");
      }
    } catch(error) {
      errorToast("Failed to save diagnosis");
    } finally {
      props.setLoading(false);
    }
  }

  const handleDiagnosisInput = (name, value) => {
    setDiagnosisForm([name], value);
  };

  return {
    diagnoses,
    diagnosisForm,
    onSaveDiagnosis,
    handleDiagnosisInput,
    onFetchDiagnoses,
    statuses,
    addDiagnosis,
    removeDiagnosis,
    updateDiagnosisStatus,
  };
}
